import { render, staticRenderFns } from "./ServiceCard.vue?vue&type=template&id=a05b4966&scoped=true&"
import script from "./ServiceCard.vue?vue&type=script&lang=js&"
export * from "./ServiceCard.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCard.vue?vue&type=style&index=0&id=a05b4966&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05b4966",
  null
  
)

export default component.exports